import { createSlice } from '@reduxjs/toolkit';

type DealerContextTypes = {
  dealerContextId: string | null;
  dealerMarket: string | null;
};

const initialState: DealerContextTypes = {
  dealerContextId: null,
  dealerMarket: null,
};

const dealerContextSlice = createSlice({
  name: 'dealerContext',
  initialState,
  reducers: {
    setDealerContext: (_state: DealerContextTypes, action) => {
      return action.payload;
    },
  },
});

export const selectDealerContext = (state: any): DealerContextTypes => state.dealerContext;
export const { setDealerContext } = dealerContextSlice.actions;
export default dealerContextSlice.reducer;
